import EventEditParent from '@/screens/EventEditParent';

export default function PrivateEventCreateParentRoute() {
  return <EventEditParent />;
}
